import { Siren, TestTubes, Bandage, PhoneCall } from "lucide-react";

interface QuickGuideProps {
  isEmergency: string;
  todayTests: string;
  immediateTx: string;
  reportWhen: string;
}

export function QuickGuide({ isEmergency, todayTests, immediateTx, reportWhen }: QuickGuideProps) {
  return (
    <div className="rounded-xl border-2 border-clinical-amber/40 bg-clinical-amber/5 p-4 shadow-sm">
      <div className="mb-3 flex items-center gap-2">
        <Siren className="h-5 w-5 text-clinical-amber" />
        <h3 className="text-sm font-bold uppercase tracking-wider text-clinical-amber">
          당직 Quick Guide
        </h3>
      </div>

      <div className="grid gap-3 sm:grid-cols-2">
        <div className="flex items-start gap-2.5">
          <div className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-clinical-red/15 text-clinical-red">
            <Siren className="h-3.5 w-3.5" />
          </div>
          <div>
            <p className="text-xs font-semibold text-clinical-red">응급 여부</p>
            <p className="text-sm">{isEmergency}</p>
          </div>
        </div>

        <div className="flex items-start gap-2.5">
          <div className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-clinical-blue/15 text-clinical-blue">
            <TestTubes className="h-3.5 w-3.5" />
          </div>
          <div>
            <p className="text-xs font-semibold text-clinical-blue">오늘 할 검사</p>
            <p className="text-sm">{todayTests}</p>
          </div>
        </div>

        <div className="flex items-start gap-2.5">
          <div className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-clinical-green/15 text-clinical-green">
            <Bandage className="h-3.5 w-3.5" />
          </div>
          <div>
            <p className="text-xs font-semibold text-clinical-green">바로 시작할 처치</p>
            <p className="text-sm">{immediateTx}</p>
          </div>
        </div>

        <div className="flex items-start gap-2.5">
          <div className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-clinical-amber/15 text-clinical-amber">
            <PhoneCall className="h-3.5 w-3.5" />
          </div>
          <div>
            <p className="text-xs font-semibold text-clinical-amber">상급자 보고</p>
            <p className="text-sm">{reportWhen}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
